export default __webpack_public_path__ + "static/eth-c33da42f510e99d95596322cf62841c1.png";